"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HRPurposeSubCategory = void 0;
const type_utils_1 = require("@transcend-io/type-utils");
exports.HRPurposeSubCategory = (0, type_utils_1.makeEnum)({
    /** Fallback sub purpose */
    HR: 'HR',
});
//# sourceMappingURL=hr.js.map